import * as app from "./routes/app";
// import * as location from "./routes/location";
// import * as user from "./routes/user";
// import * as support from "./routes/support";
// import * as companies from "./routes/companies";
// import * as s3 from "./routes/s3";
// import * as files from "./routes/files";
import * as waitlist from "./routes/waitlist";
import * as users from "./routes/users";
import * as locale from "./routes/locale";

export * from "./config";

export const routes = {
  //   app,
  //   user,
  //   support,
  //   s3,
  //   files,
  app,
  locale,
  users,
  waitlist,
};
